const setFbq = {
    fireFbq: (data, event, orderTotal) => {
        const itemArray = data;
        const contentIds = [];
        let priceArr = 0;
        const nameArr = [];
        itemArray.forEach(item => {
            contentIds.push(item.productId);
            if (event === 'AddToCart') {
                priceArr += item.amount.total;
            } else {
                priceArr += item.price.value;
            }
            nameArr.push(item.name);
        });
        window.ReactPixel.default.track(event, {
            content_type: 'product',
            content_ids: contentIds.toString().split(','),
            value: event === 'Purchase' ? orderTotal.toFixed(2) : priceArr.toFixed(2),
            content_name: nameArr.toString(),
            currency: 'INR'
        });
    }
};
export default setFbq;
